/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SubmissionCreateSubmissionParam model module.
 * @module model/SubmissionCreateSubmissionParam
 * @version 1.0
 */
class SubmissionCreateSubmissionParam {
    /**
     * Constructs a new <code>SubmissionCreateSubmissionParam</code>.
     * @alias module:model/SubmissionCreateSubmissionParam
     */
    constructor() { 
        
        SubmissionCreateSubmissionParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SubmissionCreateSubmissionParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SubmissionCreateSubmissionParam} obj Optional instance to populate.
     * @return {module:model/SubmissionCreateSubmissionParam} The populated <code>SubmissionCreateSubmissionParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SubmissionCreateSubmissionParam();

            if (data.hasOwnProperty('applicant')) {
                obj['applicant'] = ApiClient.convertToType(data['applicant'], 'String');
            }
            if (data.hasOwnProperty('competitionId')) {
                obj['competitionId'] = ApiClient.convertToType(data['competitionId'], 'Number');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('filePath')) {
                obj['filePath'] = ApiClient.convertToType(data['filePath'], 'String');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} applicant
 */
SubmissionCreateSubmissionParam.prototype['applicant'] = undefined;

/**
 * @member {Number} competitionId
 */
SubmissionCreateSubmissionParam.prototype['competitionId'] = undefined;

/**
 * @member {String} description
 */
SubmissionCreateSubmissionParam.prototype['description'] = undefined;

/**
 * @member {String} filePath
 */
SubmissionCreateSubmissionParam.prototype['filePath'] = undefined;

/**
 * @member {Number} userId
 */
SubmissionCreateSubmissionParam.prototype['userId'] = undefined;






export default SubmissionCreateSubmissionParam;

